import styled from "styled-components"

export const AnchorBtn = styled.a`
    position: fixed;
    right: 25px;
    bottom: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #37a0cd;
    color: #fff;
`